import { getAmplitudeInstance } from '../amplitudeHelpers';
import ListItemType from '../enums/ListItemType';
import MapLocation from '../enums/MapLocation';
import TrailPageType from '../enums/TrailPageType';

type logTrailSavedToastViewedParams = {
  list_id: number;
  list_type: ListItemType;
  save_location?: MapLocation;
  trail_id?: number;
  trail_page_type?: TrailPageType;
};

/**
 * The save confirmation toast (e.g., 'Trail saved') is shown to the user after they successfully save a trail or map to a list. The toast includes a 'View list' action.
 * @param params - Attributes to log with the amplitude event
 * @param params.list_id - The id of the list the item was saved to (built-in list for favorites, custom list for others).
 * @param params.list_type - The type of list the item was saved to.
 * @param params.save_location - The screen on which the user was viewing an item when they saved it to a list.
 * @param params.trail_id - The id of the trail that was saved, if applicable.
 * @param params.trail_page_type - Type of trail page where the save was initiated, if applicable.
 */
const logTrailSavedToastViewed = (
  { list_id, list_type, save_location, trail_id, trail_page_type }: logTrailSavedToastViewedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'trail saved toast viewed',
    { 'list id': list_id, 'list type': list_type, 'save location': save_location, 'trail id': trail_id, 'trail page type': trail_page_type },
    callback
  );
};

export default logTrailSavedToastViewed;
